import React, { useState, useRef,useCallback, useMemo,useLayoutEffect,useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Resizable } from 'react-resizable';
import {
  Table,
  Button,
  Row,
  Col,
  Card,
  Breadcrumb,
  Select,
  Divider,
  Form,
  Empty,
  notification
} from "antd";
import {
  HomeOutlined,
} from "@ant-design/icons";
import AccountPayableAPI from "../../../restAPI/AccountPayableAPI";
import ReportAPI from "../../../restAPI/ReportAPI";
import { useSelector } from 'react-redux';

const { Option } = Select;
const ResizableTitle = (props) => {
  const { onResize, width, children, ...restProps } = props;
  if (!width) return <th {...restProps}>{children}</th>;

  return (
    <th {...restProps}>
      <Resizable
        width={width}
        height={0}
        onResize={onResize}
        draggableOpts={{ enableUserSelectHack: false }}
        handle={
          <span
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              cursor: "col-resize",
              width: "2px",
              height: "100%",
              background: "#ffeb3b3b",
            }}
          />
        }
      >
        <div>{children}</div>
      </Resizable>
    </th>
  );
};

export default function UserTable() {
  const tableContainerRef = useRef();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [currencyType,setcurrencyType] = useState([]); // for Load Currency Types
  const [accountSearchData, setAccountSearchData] = useState([]); // to store the sorted data
  const [accountAllData,setAccountAllData] = useState([]);// to initially hold the all the documents wothout sorting
  const [searchform] = Form.useForm(); // form instance for the form
  const { token } = useSelector(state => state.auth); //get the token
  const isInitialRender = useRef(true); // to skip running on initial render the GetDataforTotalTaxAmountReport() method
  const formRef = useRef(null);

  useEffect(()=>{
    if (token !== null) {
    GetCurrancyTypes();
    }
  },[]);

useEffect(()=>{
  if(isInitialRender.current)
  {
    isInitialRender.current = false;
    return;
  }
  GetDataforTotalTaxAmountReport();
},[currencyType])

const [api, contextHolder] = notification.useNotification();
const openNotificationWithIcon = (type, message, description, placement) => {
  api[type]({
    message: message,
    description: description,
    placement
});
};

//-----------------------------------------------------------API Calls------------------------------------------------------------
 const GetCurrancyTypes = async () =>
        {
          await AccountPayableAPI.GetCurrancyTypes(token)
                .then((res) => {
                   if (res?.data) {
                             //console.log("Document Type API call responce");
                             //console.log(JSON.stringify(res.data));
                             const CurrancyTypes = res.data.map((rowValue) =>  ({
                                   value: rowValue.code,
                                   label: rowValue.currency
                              })).sort((a, b) => a.label.localeCompare(b.label));
                              CurrancyTypes.unshift({label:"All",value:"00"});
                              setcurrencyType(CurrancyTypes);
                              //console.log(accountPayableSearchData);Self-billed Credit Note, Self-billed Debit Note, Self-billed Refund, and Self-billed Invoice
                          }
                })
                .catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'No Currancy Type found', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'No Currancy Type found', `${err.message}`, 'bottomLeft');
                    }
                });
        }

  const GetDataforTotalTaxAmountReport = async () =>
        {
       // comment this when checking
       //const companyId = "6787e74b5035b0a86e7793c5";
       if(localStorage.getItem('companyId') !==null){
          await ReportAPI.GetDataforTotalTaxAmountReport(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'))
                .then((res) => {
                   if (res?.data) {
                              const rows = [];
                              let tempKey = 0;
                              res.data.map((rowValue) =>  {
                                let currencyName = currencyType.filter((type) => type.value === rowValue?.currencyType)[0]?.label;
                                 console.log("Currancy Name :- "+ JSON.stringify(currencyName));
                                rows.push({//key: rowValue?.documentMoguID,
                                  key: tempKey++,
                                  currencyType:(!rowValue?.currencyType|| rowValue?.currencyType.trim() === "")?"N/A":rowValue?.currencyType,
                                  currencyName : (!currencyName||currencyName.trim() === "")?"N/A":currencyName,
                                  transactionType : (!rowValue?.transactionType|| rowValue?.transactionType.trim() === "")?"N/A":rowValue?.transactionType,
                                  totalExcludingTax :(!rowValue.totalExcludingTax||rowValue.totalExcludingTax.trim()==="") ? "N/A" : parseFloat(rowValue.totalExcludingTax),
                                  totalIncludingTax: (!rowValue.totalIncludingTax || rowValue.totalIncludingTax.trim()==="") ? "N/A":parseFloat(rowValue.totalIncludingTax)
                                })
                              });
                              setAccountAllData(rows);
                              setAccountSearchData(rows);
                          }
                })
                .catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'No data found', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'No data found', `${err.message}`, 'bottomLeft');
                    }
                });
        }
        else{
          setAccountSearchData([]);
          setAccountAllData([]);
          openNotificationWithIcon('info', 'Information', "Please select a Group and Company.", 'bottomLeft');
        }
      
        }
//------------------------------------------------------------End of API calls--------------------------------------------------
  //-------------------------------------------------------Form Controls-------------------------------------------------------------
  const onFinish = (values) => {
    console.log(JSON.stringify(values));
     console.log('before filterd:', JSON.stringify(accountAllData));
  let filtered = accountAllData;
  if(values.transactiontype|| (values.transactiontype?.trim()||"") !== "")
    {
      filtered = filtered.filter(element => values.transactiontype === "all" || element.transactionType.toLowerCase().includes(values.transactiontype.toLowerCase()));
      console.log("inside Transaction Type",JSON.stringify(filtered));
    }
    //console.log("after Transaction Types",JSON.stringify(filtered));
    //This must be change in future if document type and classification should be compulsry for search 
    if(values.currencyType && (values.currencyType?.trim()||"") !== "00" && (values.currencyType?.trim()||"") !== "")
      {
        filtered = filtered.filter(element => element.currencyType === values.currencyType);
       console.log("inside currency Type",JSON.stringify(filtered));
      }

      setAccountSearchData(filtered);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Validation Failed:', errorInfo);
    //message.error('Please check the form for errors.');
  };

  //------------------------------------------------------------------------------End of Forms-----------------------------------------------------------
  const home = () => {
    navigate('/dashboard');
  };

  const handleFormClear = () => {
    formRef.current.resetFields();
    GetDataforTotalTaxAmountReport();
  };

  const initialColumns = [
    {
      title: "Currency Type",
      dataIndex: "currencyName",
      key: "currencyName",
      sorter: (a, b) => a.currencyType.localeCompare(b.currencyName),
      percentageWidth: 0.20,
    },
    {
      title: "Transaction Type",
      dataIndex: "transactionType",
      key: "transactionType",
      sorter: (a, b) => a.transactionType.localeCompare(b.transactionType),
      percentageWidth: 0.20,
    },
    {
      title: "Total Excluding Tax",
      dataIndex: "totalExcludingTax",
      key: "totalExcludingTax",
      percentageWidth: 0.20,
      render: (price) => Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      //render: (price) => `${price.toFixed(2)}`
      //sorter: (a, b) => new Date(a.uploadDate) - new Date(b.uploadDate),
    },
    {
      title: "Total Including Tax",
      dataIndex: "totalIncludingTax",
      key: "totalIncludingTax",
      percentageWidth: 0.20,
      render: (price) => Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      //sorter: (a, b) => a.uploadedBy.localeCompare(b.uploadedBy),
    },
  ];
  const navigate = useNavigate();

   // Compute an initial container width using window.innerWidth as fallback.
   const initialContainerWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;

   // Set initial column widths based on the fallback container width.
   const [columns, setColumns] = useState(
     initialColumns.map(col => ({
       ...col,
       width: Math.floor(initialContainerWidth * col.percentageWidth),
     }))
   );
 
   // Function to update column widths based on the measured container.
   const updateColumnWidths = useCallback(() => {
     if (tableContainerRef.current) {
       const containerWidth = tableContainerRef.current.offsetWidth;
       setColumns(initialColumns.map(col => ({
         ...col,
         width: Math.floor(containerWidth * col.percentageWidth),
       })));
     }
   }, [initialColumns]);
 
   // Use useLayoutEffect to update column widths as soon as the component is mounted.
   useLayoutEffect(() => {
     updateColumnWidths();
   }, [updateColumnWidths]);
 
   // Update widths on window resize.
   useEffect(() => {
     window.addEventListener('resize', updateColumnWidths);
     return () => window.removeEventListener('resize', updateColumnWidths);
   }, [updateColumnWidths]);
 
 
 const handleResize = useCallback(
     (index) => (e, { size }) => {
       setColumns((prevColumns) => {
         const newColumns = [...prevColumns];
         newColumns[index] = { ...newColumns[index], width: size.width };
         return newColumns;
       });
     },
     []
   );
   
   const mergedColumns = useMemo(
     () =>
       columns.map((col, index) => ({
         ...col,
         onHeaderCell: (column) => ({
           width: column.width,
           onResize: handleResize(index),
         }),
       })),
     [columns, handleResize]
   );
  return (
    <Row>
       {contextHolder}
      <Col md={24}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item href="/dashboard">
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            Report
          </Breadcrumb.Item>
          <Breadcrumb.Item>Total Tax Amount Report</Breadcrumb.Item>
        </Breadcrumb>
        <div className="border-container">
          <Button
            type="primary"
            variant="dashed"
            className="card-button"
            size="large"
            icon={<HomeOutlined />}
            onClick={home}
            shape="circle"
          />
          <Card title="Total Tax Amount Report" bordered={true}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Form
                form={searchform}
                ref={formRef}
                layout="vertical"
                style={{
                  width: "65%",
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{}}
              >
                <Row gutter={24}>
                 
                 
                  <Col lg={8} md={24} sm={24} xs={24} offset={4}>
                    <Form.Item
                      label="Transaction Type"
                      name="transactiontype"
                      rules={[
                        {
                          required: true,
                          message: "Please select a Transaction Type!",
                        },
                      ]}
                    >
                      <Select size="large" placeholder="All">
                      <Option value="all">All</Option>
                      <Option value="Accounts receivable">Accounts Receivable</Option>
                      <Option value="Accounts payable">Accounts Payable</Option>


                      </Select>
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item
                      label="Currency Type"
                      name="currencyType"
                      rules={[
                        {
                          required: true,
                          message: "Please select a Currency Type!",
                        },
                      ]}
                    >
                      <Select size="large" placeholder="All" options={currencyType} showSearch
                       filterOption={(input, option) =>
                       option.label.toLowerCase().includes(input.toLowerCase())}>
                      </Select>
                    </Form.Item>
                  </Col>
                
                
              
                </Row>
                <Row justify="center" gutter={16}>
                  <Col>
                    <Button size="large" onClick={handleFormClear}>
                      Clear
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      size="large"
                      type="primary"
                      htmlType="submit">
                      Search
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
            <Divider />
            <div
              style={{
                maxWidth: '100%', // Ensure the container doesn't exceed its width
                overflowX: 'auto', // Enable horizontal scroll
              }}
            >
            <Table
              dataSource={accountSearchData}
              components={{
                header: {
                  cell: ResizableTitle, 
                },
              }}
              columns={mergedColumns}
              locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No records found!'/> }}
              pagination={{ pageSize: 5 }}
              size="small"

            />
            </div>
            <br />

          </Card>
        </div>


      </Col>
     


    </Row>
  );
}
